"use client";

import * as React from "react";
import { ArrowRight, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const favorites = [{
  name: "Submit a\nRequest",
  description: "Provide procedure details, date, specialty, and staffing needs.",
  image: "https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-Apr-1-2026-06_44_04-PM.png?v=eidaonqnjc7",
  price: "01"
}, {
  name: "Requirements Review",
  description: "Atlas reviews the request and identifies the right professional.",
  image: "https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-Apr-1-2026-06_44_28-PM.png?v=dmwa2qljq0n",
  price: "02"
}, {
  name: "Coverage Coordination",
  description: "Scheduling, communication, and logistics are handled efficiently.",
  image: "https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-Apr-1-2026-06_46_13-PM.png?v=bk0bmciz90c",
  price: "03"
}, {
  name: "Confirmation & Support",
  description: "Coverage is confirmed with ongoing support as needed.",
  image: "https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-Apr-1-2026-06_46_11-PM.png?v=xn27afcp0y",
  price: "04"
}];
export default function KitchenFavorites() {
  return <section data-section-id="194" id="howcoverageworks" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="font-sans font-bold text-4xl md:text-5xl text-foreground mb-4 tracking-tight">
              How Coverage Works
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-xl leading-relaxed">
              Our streamlined process ensures your facility gets the surgical expertise it needs, 
              exactly when it needs it, with zero administrative friction.
            </p>
          </div>
          <div className="hidden md:block">
            <Button className="rounded-full bg-gradient-to-r from-[#1E4FA3] to-[#0A2E6E] text-white hover:opacity-90 border-none px-8 shadow-lg" asChild>
              <Link to="/facilities/">
                Request Coverage <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {favorites.map((item, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <Card className="h-full border-none shadow-none bg-transparent group">
                  <CardContent className="px-6 h-full flex flex-col !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] !p-[20px] !rounded-lg !border-none border-[rgb(10,27,51)]">
                    <div className="relative aspect-square overflow-hidden rounded-xl bg-white mb-6 flex items-center justify-center p-8 transition-all duration-300 group-hover:shadow-md border border-border/20 !border-none border-1 border-[oklab(0.603001-0.0053722-0.013398/0.2)]">
                      <img src={item.image} alt={item.name} className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105 !shadow-none border-[rgb(10,27,51)] !border-1 !border-none" />
                      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-sm text-secondary">
                          <Star className="h-4 w-4 fill-current" />
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex flex-col flex-grow">
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="font-sans font-semibold text-xl text-foreground group-hover:text-secondary transition-colors duration-300">
                          {item.name}
                        </h3>
                        <span className="font-mono text-xs font-bold text-secondary bg-secondary/10 px-2 py-1 rounded-md">
                          STEP {item.price}
                        </span>
                      </div>
                      <p className="text-muted-foreground text-sm leading-relaxed mb-4 flex-grow">
                        {item.description}
                      </p>
                      <Button variant="link" className="p-0 h-auto self-start text-secondary hover:text-secondary/80 font-semibold" asChild>
                        <Link to="/facilities/">
                          Get Started <ArrowRight className="ml-2 h-4 w-4" />
                        </Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <div className="flex justify-end gap-2 mt-8 md:hidden">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-white border-border/40" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-white border-border/40" />
          </div>
          <div className="hidden md:block">
             <CarouselPrevious className="left-0 -translate-x-1/2 bg-background/80 backdrop-blur-sm hover:bg-background border-border/40" />
             <CarouselNext className="right-0 translate-x-1/2 bg-background/80 backdrop-blur-sm hover:bg-background border-border/40" />
          </div>
        </Carousel>

        <div className="mt-8 md:hidden">
          <Button className="w-full rounded-full bg-gradient-to-r from-[#1E4FA3] to-[#0A2E6E] text-white" asChild>
            <Link to="/facilities/">
              Request Coverage
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}